import { Router, ActivatedRoute, Params } from '@angular/router';
import { Component, OnInit, Input } from '@angular/core';
import { CustomProffixService, UserSessionService } from '../../services';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

import {
  Login,
  Mitarbeiter,
  MitarbeiterService,
  StundeninfoService,
  Stundeninfo
} from '@proffix/restapi-angular-library';

@Component({
  selector: 'app-my-hours',
  templateUrl: './my-hours.component.html',
  styleUrls: ['./my-hours.component.css']
})
export class MyHoursComponent implements OnInit {
  proffixLogin: Login = null;

  isLoaded = false;
  isManager = false;
  isTeamleiter = false;

  filterMitarbeiterNr = 0;
  filterDatum: NgbDateStruct;

  listOfMitarbeiter: Mitarbeiter[];
  stundenInfo: Stundeninfo;

  constructor(
    private _customProffixService: CustomProffixService,
    private _userSessionService: UserSessionService,
    private _mitarbeiterService: MitarbeiterService,
    private _stundenInfoService: StundeninfoService) {

  }

  ngOnInit() {
    const now = new Date();
    this.filterDatum = { year: now.getFullYear(), month: now.getMonth() + 1, day: now.getDate() };

    this._userSessionService.getProffixLogin().subscribe(data => {
      this.proffixLogin = data;
      this.isManager = this._userSessionService.isManager();
      this.isTeamleiter = this._userSessionService.isTeamleiter();

      if (data != null) {
        this.filterMitarbeiterNr = data.Mitarbeiter.MitarbeiterNr;
      } else {
        this.filterMitarbeiterNr = 0;
      }

      // load the list of all Mitarbeiter that the current user is allowed to see
      this._customProffixService
        .getListOfAssignedMitarbeiter(this.proffixLogin.Mitarbeiter.MitarbeiterNr, this.isManager)
        .subscribe(result => {
          this.listOfMitarbeiter = this.SortMitarbeiterByName(result);
        });
    });

  }


  search() {
    this.loadSaldi();
  }

  loadSaldi() {
    this.isLoaded = false;

    this._customProffixService.getAllStundeninfo({
      mitarbeiter: this.filterMitarbeiterNr,
      datum: this.filterDatum.day + '.' + this.filterDatum.month + '.' + this.filterDatum.year,
    })
      .subscribe((result) => {
        this.stundenInfo = result;
        this.isLoaded = true;
      });
  }

  private SortMitarbeiterByName(listOfMitarbeiter: Mitarbeiter[]): Mitarbeiter[] {
    listOfMitarbeiter.sort((x, y) => {
      if (x.Adresse.Name < y.Adresse.Name) {
        return -1;
      } else if (x.Adresse.Name > y.Adresse.Name) {
        return 1;
      } else {
        return 0;
      }
    });

    return listOfMitarbeiter;
  }

  public filterVisibleMitarbeiter(ma: Mitarbeiter): boolean {
    return ma && ma.Zusatzfelder && ma.Zusatzfelder.Z_Zeitmanagement_Rolle && ma.Zusatzfelder.Z_Zeitmanagement_Rolle !== '';
  }
}



// WEBPACK FOOTER //
// C:/.NET Projects/Angular Apps/TimeManagement/src/app/dialogs/my-hours/my-hours.component.ts